import { createKYCRenewalReducer } from "@repo/redux/kyc-renewal";

// Create reducer with dashboard specific initial state (current date, 0 months ahead)
export default createKYCRenewalReducer(0);
